import { render, staticRenderFns } from "./SupplierRawMaterialDietarySuitability.vue?vue&type=template&id=44c2ab09&scoped=true"
import script from "./SupplierRawMaterialDietarySuitability.vue?vue&type=script&lang=js"
export * from "./SupplierRawMaterialDietarySuitability.vue?vue&type=script&lang=js"
import style0 from "./SupplierRawMaterialDietarySuitability.vue?vue&type=style&index=0&id=44c2ab09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c2ab09",
  null
  
)

export default component.exports